export default {
  getActiveConversation: state => state.activeConversation,
  getConversations: state => state.conversations,
  getMessages: state => state.activeConversation.messages,
};



// WEBPACK FOOTER //
// ./src/store/modules/chat/getters.js